export enum AnalyticsAccessType {
    PricingTier = 'PRICING_TIER',
    FeatureAccess = 'FEATURE_ACCESS',
}

/** Catalog row from `analytics_access`; PRICING_TIER rows replace legacy pricing tiers. */
export class AnalyticsAccessEntity {
    id: number;

    name: string;

    type: AnalyticsAccessType;

    lookerGroupId: string;

    lookerNavigationFolderId?: string | null;

    createdAt?: string;

    lastModifiedOn?: string;
}
